<template>

    <!-- begin::PANEL ADMINISTRATION -->
    <div id="kt_quick_actions" ref="kt_quick_actions" class="offcanvas offcanvas-left p-5">
      
      <!--begin::Header - PANEL ADMINISTRATION-->
      <div class="offcanvas-header d-flex align-items-center justify-content-between pb-5" kt-hidden-height="56" style="">
        <h3 class="font-weight-bold m-0">{{$t("adminPanel.title")}}</h3>
        <a href="#" class="btn btn-xs btn-icon btn-light btn-hover-primary" id="kt_quick_actions_close">
          <i class="ki ki-close icon-xs text-muted"></i>
        </a>
      </div>
      <!--end::Header-->
      
      <!--begin::Content-->
      <perfect-scrollbar class="offcanvas-content mr-n5 scroll" style="max-width: 90vh; position: relative;">
      <div class="mobile-button d-flex flex-wrap scroll ps">
        
          <!--begin::Item - Gestion Contenu-->
          <div class="button-menu col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <router-link :to="{ name: 'gestionContenus' }">
              <a href="#" class="btn-custom btn btn-block btn-light btn-hover-primary text-center py-sm-5 py-lg-10 px-5 px-xs-2">
                <span class="svg-icon svg-icon-3x svg-icon-primary m-0">
                  <inline-svg src="/media/svg/icons/Files/Media.svg" />
                </span>
                <span class="txt-custom d-block font-weight-bold font-size-h6">
                  {{$t("adminPanel.content")}}
                </span>
              </a>
            </router-link>
          </div>
          <!--end::Item - Gestion Contenu-->

          <!--begin::Item - Gestion Clients -->
          <div class="button-menu col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <router-link :to="{ name: 'gestionClients' }">
              <a href="#" class="btn-custom btn btn-block btn-light btn-hover-primary text-center py-sm-5 py-lg-10 px-5 px-xs-2">
                <span class="svg-icon svg-icon-3x svg-icon-primary m-0">
                  <inline-svg src="/media/svg/icons/General/User.svg"/>
                </span>
                <span class="txt-custom d-block font-weight-bold font-size-h6">
                  {{$t("adminPanel.client")}}
                </span>
              </a>
            </router-link>
          </div>
          <!--end::Item - Gestion Clients -->

          <!--begin::Item - Gestion Contenu Clients -->
          <div class="button-menu col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <router-link :to="{ name: 'gestionContenuClients' }">
              <a href="#" class="btn-custom btn btn-block btn-light btn-hover-primary text-center py-sm-5 py-lg-10 px-5 px-xs-2">
                
                <span class="svg-icon svg-icon-3x svg-icon-primary m-0">
                  <inline-svg src="/media/svg/icons/Files/Upload-folder.svg"/>
                </span>
                <span class="txt-custom d-block font-weight-bold font-size-h6">
                  {{$t("adminPanel.clientContent")}}
                </span>
                
              </a>
            </router-link>  
          </div>
          <!--end::Item - Gestion Contenu Clients -->

          <!--begin::Item - Gestion Bosco -->
          <div class="button-menu col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <router-link :to="{ name: 'gestionCompteBosco' }">    
              <a href="#" class="btn-custom btn btn-block btn-light btn-hover-primary text-center py-sm-5 py-lg-10 px-5 px-xs-2">
                <span class="svg-icon svg-icon-3x svg-icon-primary m-0">
                  <!--begin::Svg Icon-->
                  <inline-svg src="/media/svg/icons/General/Shield-protected.svg" />
                  <!--end::Svg Icon-->
                </span>
                <span class="txt-custom d-block font-weight-bold font-size-h6">
                  {{$t("adminPanel.bosco")}}
                </span>
              </a>
            </router-link>
          </div>
          <!--end::Item - Gestion Bosco -->

          <!--begin::Item - Gestion Partenaires -->
          <div class="button-menu col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <router-link :to="{ name: 'gestionPartenaires' }">
              <a href="#" class="btn-custom btn btn-block btn-light btn-hover-primary text-center py-sm-5 py-lg-10 px-5 px-xs-2">
                <span class="svg-icon svg-icon-3x svg-icon-primary m-0">
                  <inline-svg src="/media/svg/icons/Communication/Group.svg" />
                </span>
                <span class="txt-custom d-block font-weight-bold font-size-h6">
                  {{$t("adminPanel.partners")}}
                </span>
              </a>
            </router-link>
          </div>
          <!--end::Item - Gestion Partenaires -->

          <!--begin::Item - KPI -->
          <div class="button-menu col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <router-link :to="{ name: 'adminKPI' }">
              <a href="#" class="btn-custom btn btn-block btn-light btn-hover-primary text-center py-sm-5 py-lg-10 px-5 px-xs-2">
                <span class="svg-icon svg-icon-3x svg-icon-primary m-0">
                  <inline-svg src="/media/svg/icons/General/Graph.svg" />
                </span>
                <span class="txt-custom d-block font-weight-bold font-size-h6">
                  {{$t("adminPanel.KPI")}}
                </span>
              </a>
            </router-link>
          </div>
          <!--end::Item - KPI -->

          <!--begin::Item - Gestion Notification -->
          <div class="button-menu col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <router-link :to="{ name: 'gestionNotfications' }">
              <a href="#" class="btn-custom btn btn-block btn-light btn-hover-primary text-center py-sm-5 py-lg-10 px-5 px-xs-2">
                <span class="svg-icon svg-icon-3x svg-icon-primary m-0">
                  <inline-svg src="/media/svg/icons/General/Notifications1.svg" />
                </span>
                <span class="txt-custom d-block font-weight-bold font-size-h6">
                  Gestion des Notifications
                </span>
              </a>
            </router-link>
          </div>
          <!--end::Item - Gestion Notification-->
      </div>
      </perfect-scrollbar>
      <!-- end::CONTENT - PANEL ADMINISTRATION -->
    </div>
    <!-- end::PANEL ADMINISTRATION -->
  <!-- </div> -->
  
</template>

<style lang="scss" scoped>

.scroll.scroll-pull {
  padding-right: 20px !important;
  margin-right: -40px !important;
}

  @media (max-width: 600px){
    .mobile-button{
      display: flex;
      flex-direction: column;
      padding-right: 0px;
    }
    .button-menu{
      padding-bottom: 0px;
    }
    .btn-custom{
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .txt-custom{
      font-size: 1rem !important;
      font-weight: 300 !important;
      text-align: left;
    }
    .svg-icon{
      padding-right: 1rem !important;
    }
    
  }
</style>

<script>
import KTLayoutQuickActions from "@/assets/js/layout/extended/quick-actions.js";

export default {
  name: "KTQuickActions",
  data() {
    return {};
  },
  mounted() {
    // Init Quick Actions Offcanvas Panel
    KTLayoutQuickActions.init(this.$refs["kt_quick_actions"]);
  }
};
</script>
